import t from "./getParentNode.js";
import e from "./isScrollParent.js";
import o from "./getNodeName.js";
import { isHTMLElement as m } from "./instanceOf.js";
function i(r) {
  return ["html", "body", "#document"].indexOf(o(r)) >= 0 ? r.ownerDocument.body : m(r) && e(r) ? r : i(t(r));
}
export {
  i as default
};
